import { gql } from 'apollo-angular';

export const CITADEL_PERMISSIONS_QUERY = gql`
  query citadelPermissions {
    citadelPermissions
  }
`;